<div class="input-group">
  <input #field
         [type]="showLookup ? 'hidden' : 'text'"
         [class.form-control]="!showLookup"
         [ngModel]="innerValue"
         (ngModelChange)="writeValue($event)"
         [disabled]="disabled"
         [required]="required">
  @if (showLookup) {
    <input type="text"
           class="form-control"
           [(ngModel)]="typeInValue"
           [required]="required"
           (ngModelChange)="writeValue($event)"
           [disabled]="disabled"
           [readOnly]="disabled || readOnly || selected">
    <div class="input-group-append">
      @if (innerValue || typeInValue) {
        <button
          type="button"
          class="clear-search"
          [disabled]="disabled"
          (click)="clear()">
          <i class="fas fa-times-circle"></i>
        </button>
      }
      @if (!innerValue) {
        <button
          class="btn btn-action"
          [disabled]="disabled"
          (click)="!disabled && (showSearch = true)"
          type="button">
          <reporter-icon icon="Search"></reporter-icon>
        </button>
      }
    </div>
  }
</div>

@if (showSearch) {
  <reporter-vehicles-search
    [show]="showSearch"
    (close)="close()"
    (selectVehicle)="select($event)">
  </reporter-vehicles-search>
}

